export const ENDPOINT = {
  AUTH: {
    LOGIN: "/v1/auth/desk/login",
    REFRESH: "/v1/auth/desk/refreshToken",
    LOGOUT: "/v1/auth/desk/logout",
    INFO: "/v1/auth/desk/info",
  },
  MONITORING: {
    LIST: "/v1/dashboard/performance",
    SLA: "v1/dashboard/pods",
    TAG_I: "/v1/dashboard/monitoring-tag-i",
    TAG_I_SHIPMENTS: '/v1/dashboard/monitoring-tag-i/shipments',
  },
  TRACKING: {
    AUTH: "/v1/tracking/auth",
    TRIP: "/v1/tracking/trip",
    CREW: "/v1/tracking/crew",
    REPORT: "/v1/tracking/report",
    ACTIVECREW: "/v1/tracking/active-crews",
    THREEPL: "v1/tracking/trip-3pl",
    REPORT3PL: "v1/tracking/report-3pl",
  },
  ROLE: {
    HISTORY: "/v1/auth/desk/historyRole",
    EMPLOYEE_LIST: "/v1/auth/desk/employees",
    UPDATE: "/v1/auth/desk/changeRole",
    RESET: "/v1/auth/desk/resetRole",
  },
  CLAIM_OPERATIONAL_SAPA: {
    // counter
    CLAIM_COUNTER: "/v1/vehicles/get-counter",

    // vehicle config
    VEHICLE_LIST: "/v1/vehicles/list",
    VEHICLE_DETAIL: "/v1/vehicles",
    VEHICLE_REQUEST_LIST: "/v1/vehicles/submissions",
    VEHICLE_APPROVAL: "/v1/vehicles/submission",
    VEHICLE_REJECT_LVL1: "/v1/vehicles/submission/reject-lv1",
    VEHICLE_OPTIONS: "/v1/vehicles/submissions/get-vehicle-options",
    VEHICLE_SUBMIT: "/v1/vehicles/submit",
    VEHICLE_ACTIVATION_SUBMIT: "/v1/vehicles/request/activation",
    VEHICLE_ACTIVATION_APPROVAL: "/v1/vehicles/activation",
    VEHICLE_MUTATION_APPROVAL: "/v1/vehicles/mutation",
    VEHICLE_MUTATION_SUBMIT: "/v1/vehicles/mutation/submit",
    NIK_LIST: "/v1/vehicles/get-nik-list",
    VEHICLE_DETAIL_BY_PLATE_NUMBER: "/v1/vehicles/mutation/platenumber-detail",

    // claim bbm
    CLAIM_LIST: "v1/claim/list",
    CLAIM_VEHICLE_OPTIONS: "/v1/claim/bbm/get-claim-vehicles",
    CLAIM_BBM_DETAIL: "/v1/claim/bbm/detail",
    CLAIM_BBM_SUBMISSION_APPROVE_LVL1: "/v1/claim",
    CLAIM_DETAIL_BBM_SUBMISSION: "/v1/claim/bbm/submit-claim-detail",
    CLAIM_CREATE_PRIVATE_BBM_SUBMISSION: "/v1/claim/bbm/private/submit",
    CLAIM_REJECT_SUBMISSION: "/v1/claim",

    // maintenance
    VEHICLE_MAINTENANCE: "/v1/claim/maintenance",
    VEHICLE_MAINTENANCE_VEHICLES: "/v1/claim/maintenance/vehicles",
    VEHICLE_MAINTENANCE_REASON: "/v1/claim/maintenance/get-reasons",
    VEHICLE_MAINTENANCE_SUBMIT: "/v1/claim/maintenance/submit",
  },
  REFUND: {
    REFUND_LIST: "/v1/retur/monitor/refund",
    EXPORT_REFUND_DATA: "/v1/retur/monitor/refund/export-excel"
  }
};
